import { alpha, styled } from '@mui/material';

import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { MdOutlineAttachMoney } from 'react-icons/md';

export const LoadingProgressStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '90vw',
  height: '25vh',
  alignItems: 'center',
  gap: 16,
});

export const TableCellHeaderStyled = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#E7E7E7',
  color: theme.palette.global.black,
  fontWeight: 600,
  border: '1px solid #B0B0B0',
  fontSize: '12px',
  borderRight: 'none',
  padding: '8px',
  '&:last-of-type': {
    borderRight: '1px solid #B0B0B0',
  },
}));

export const TableCellBodyStyled = styled(TableCell)({
  fontSize: '12px',
  border: '1px solid #B0B0B0',
  borderRight: 'none',
  borderTop: 'none',
  padding: '8px',
  '&:last-of-type': {
    borderRight: '1px solid #B0B0B0',
  },
});

export const FirstLayerRow = styled(TableRow)({
  backgroundColor: '#D1D1D1',
});

export const SecondLayerRow = styled(TableRow)({
  backgroundColor: '#F6F6F6',
});

export const FooterCellStyled = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#E7E7E7',
  fontWeight: 600,
  color: theme.palette.global.black,
  border: '1px solid #B0B0B0',
  borderTop: 'none',
  padding: '8px',
  '&:first-of-type': {
    borderRight: 'none',
  },
  '&:last-of-type': {
    borderLeft: 'none',
  },
}));

export const IconStyled = styled(MdOutlineAttachMoney)(({ theme }) => ({
  color: alpha(theme.palette.global.lightgray, 0.5),
  fontSize: 200,
}));

export const CustomCheckbox = styled(Checkbox)({
  padding: 0,
});
